<template>
    <div class="index-part">
        <div class="welcome-section">
            <h1 class="welcome-title">欢迎回来！</h1>
            <p class="welcome-message">每一天都是新的开始，愿您在这里找到灵感与动力，继续创造美好的未来！</p>
            <p class="welcome-quote">“成功不是终点，失败也并非末日，最重要的是继续前进的勇气。” —— 温斯顿·丘吉尔</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Dashboard',
};
</script>

<style scoped>
.index-part {
    height: 100vh;
    background-color: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
}

.welcome-section {
    text-align: center;
    padding: 50px;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.welcome-title {
    font-size: 2.5rem;
    color: #303133;
    margin-bottom: 20px;
}

.welcome-message {
    font-size: 1.2rem;
    color: #606266;
    margin-bottom: 20px;
}

.welcome-quote {
    font-size: 1rem;
    color: #909399;
    font-style: italic;
}
</style>